import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiClient, getApiBase } from '../lib/api';

const SuperAuthCtx = createContext(null);
const API = getApiBase();

export function SuperAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('super_token');
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    apiClient
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (r.data?.role === 'superadmin') setUser(r.data);
        else {
          localStorage.removeItem('super_token');
          setUser(false);
        }
      })
      .catch(() => {
        localStorage.removeItem('super_token');
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const loginStep1 = async (email, password) => {
    const { data } = await apiClient.post(`${API}/auth/login`, { login: email, password });
    if (data.token) {
      localStorage.setItem('super_token', data.token);
      setUser(data.user || data);
      return { done: true, user: data.user || data };
    }
    return {
      done: false,
      mfaToken: data.mfa_token,
      setup: data.totp_setup_required,
      otpauthUri: data.otpauth_uri,
      user: data.user,
    };
  };

  const verifyTotp = async (mfaToken, code) => {
    const { data } = await apiClient.post(`${API}/auth/totp/verify`, {
      mfa_token: mfaToken,
      code,
    });
    localStorage.setItem('super_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('super_token');
    setUser(false);
  };

  return (
    <SuperAuthCtx.Provider value={{ user, ready, loginStep1, verifyTotp, logout }}>
      {children}
    </SuperAuthCtx.Provider>
  );
}

export function useSuperAuth() {
  return useContext(SuperAuthCtx);
}
